/** Local calendar date as `YYYY-MM-DD` (avoids UTC off-by-one from `toISOString`). */
export function localTodayIsoDate(): string {
  const now = new Date();
  const yy = now.getFullYear();
  const mm = String(now.getMonth() + 1).padStart(2, '0');
  const dd = String(now.getDate()).padStart(2, '0');
  return `${yy}-${mm}-${dd}`;
}

/**
 * Returns `count` consecutive calendar dates ending at `endIso` (inclusive),
 * oldest first. `endIso` must be `YYYY-MM-DD`.
 */
export function inclusiveCalendarDateRangeEnd(endIso: string, count: number): string[] {
  if (count < 1) return [];
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(endIso.trim());
  if (!m) return [];
  const y = Number(m[1]);
  const mo = Number(m[2]);
  const d = Number(m[3]);
  if (!Number.isFinite(y) || !Number.isFinite(mo) || !Number.isFinite(d)) return [];

  const out: string[] = [];
  for (let k = count - 1; k >= 0; k--) {
    const dt = new Date(y, mo - 1, d - k);
    const yy = dt.getFullYear();
    const mm = String(dt.getMonth() + 1).padStart(2, '0');
    const dd = String(dt.getDate()).padStart(2, '0');
    out.push(`${yy}-${mm}-${dd}`);
  }
  return out;
}
